import Handler from "../Handler";

class SendThrowableBroadcastHandler extends Handler {
  execute(data) {
    let receivedData = JSON.parse(data);
    this.service.processThrowablesOnTable(receivedData);
  }
}

export default SendThrowableBroadcastHandler;
// sendThrowableB#{“fromPlayerName”:””,”toPlayerName”:””,”tableId”:””,”throwableId”:””,”statusCode”:200}
